import { Fragment, useCallback, useEffect, useState } from "react"
import { Badge, Button, Card, Col, Collapse, Form, Modal, Pagination, Row, Spinner, Table } from "react-bootstrap"
import { getAllData, getDateInitMonth } from "../../services/Servicos"
import { getErrorMessage } from "../../services/helpers"
import ModalErrorPretty from "../modal/ModalErrorPretty"
import ExportToExcel from "../exportToExcel/ExportToExcel"

const METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE"]
const ITENS_POR_PAGINA = 50

const levelVariant = (level) => {
    if (level === "error") return "danger"
    if (level === "warn") return "warning"
    return "success"
}

const FILTERS_INIT = () => {
    const { data_inicial, data_final } = getDateInitMonth()
    return {
        date_inicio: data_inicial,
        date_fim: data_final,
        userId: "",
        empresas_id: "",
        email: "",
        method: "",
        path: "",
    }
}

export default function LgpdLogs() {
    const [filters, setFilters] = useState(FILTERS_INIT)
    const [resultado, setResultado] = useState({ total: 0, data: [] })
    const [paginaAtual, setPaginaAtual] = useState(1)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({ show: false, message: "" })
    const [detalhes, setDetalhes] = useState(null)

    const emailsDisponiveis = [...new Set(
        resultado.data.map((l) => l.usuario?.email).filter(Boolean)
    )]

    const buscar = useCallback(async () => {
        setLoading(true)
        try {
            const params = {}
            Object.entries(filters).forEach(([k, v]) => {
                if (v !== "") params[k] = v
            })
            params.page = paginaAtual
            params.limit = ITENS_POR_PAGINA
            const resp = await getAllData("lgpd/logs", params)
            setResultado(resp.data)
        } catch (err) {
            setError({ show: true, message: getErrorMessage(err) })
        } finally {
            setLoading(false)
        }
    }, [filters, paginaAtual])

    useEffect(() => {
        buscar()
    }, [buscar])

    const handleChange = (e) => {
        const { name, value } = e.target
        setFilters((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setPaginaAtual(1)
        buscar()
    }

    const handleLimpar = () => {
        setFilters(FILTERS_INIT)
        setPaginaAtual(1)
    }

    const totalRegistros = Number(resultado.total) || 0
    const totalPaginas = Math.max(1, Math.ceil(totalRegistros / ITENS_POR_PAGINA))
    const paginaNormalizada = Math.min(paginaAtual, totalPaginas)
    const inicioFaixa = totalRegistros === 0 ? 0 : ((paginaNormalizada - 1) * ITENS_POR_PAGINA) + 1
    const fimFaixa = Math.min(paginaNormalizada * ITENS_POR_PAGINA, totalRegistros)
    const paginaInicio = Math.max(1, paginaNormalizada - 2)
    const paginaFim = Math.min(totalPaginas, paginaNormalizada + 2)
    const paginasVisiveis = []
    for (let p = paginaInicio; p <= paginaFim; p += 1) {
        paginasVisiveis.push(p)
    }

    return (
        <Fragment>
            <Card className="card-user">
                {/* ---- FILTROS ---- */}
                <div className="section-filters-table mb-3">
                    <div className="card-header pb-2">
                        <Row className="justify-content-between align-items-center">
                            <Col>
                                <h3>Logs LGPD</h3>
                            </Col>
                        </Row>
                    </div>

                    <Form onSubmit={handleSubmit} className="px-3 pb-3 pt-2">
                        <Row className="g-2 align-items-end">
                            <Col sm="12" md="2">
                                <Form.Label>Data inicial</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="date_inicio"
                                    value={filters.date_inicio}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col sm="12" md="2">
                                <Form.Label>Data final</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="date_fim"
                                    value={filters.date_fim}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col sm="12" md="2">
                                <Form.Label>Método</Form.Label>
                                <Form.Select
                                    name="method"
                                    value={filters.method}
                                    onChange={handleChange}
                                >
                                    <option value="">Todos</option>
                                    {METHODS.map((m) => (
                                        <option key={m} value={m}>{m}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col sm="12" md="2">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control
                                    type="text"
                                    list="lgpd-emails-list"
                                    name="email"
                                    placeholder="user@empresa.com"
                                    value={filters.email}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                <datalist id="lgpd-emails-list">
                                    {emailsDisponiveis.map((e) => (
                                        <option key={e} value={e} />
                                    ))}
                                </datalist>
                            </Col>
                            <Col sm="12" md="2">
                                <Form.Label>Path</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="path"
                                    placeholder="/gestao"
                                    value={filters.path}
                                    onChange={handleChange}
                                />
                            </Col>

                            <Col sm="12" className="d-flex gap-2 mt-2">
                                <Col sm='12' md='6' lg='2'>
                                    <div className="">
                                        <div
                                            variant={"primary"}
                                            className="btn btn-primary button-export-config"
                                            style={{ borderRadius: '10px' }}
                                            onClick={buscar}
                                        > {loading
                                            ? <><Spinner animation="border" size="sm" /> Buscando...</> : "Buscar"}</div>
                                    </div>
                                </Col>


                                <Col sm='12' md='6' lg='2'>
                                    <ExportToExcel tableName="Logs" reference={resultado.data.length ? resultado.data : []} />
                                </Col>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* ---- TABELA ---- */}
                <div className="section-filters-table">
                    <div className="card-header pb-2">
                        <Row className="justify-content-between align-items-center">
                            <Col>
                                <h3 style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    Registros
                                    {loading && <Spinner animation="border" size="sm" />}
                                </h3>
                            </Col>
                            <Col sm="auto">
                                <Badge bg="secondary" className="fs-6">
                                    Total: {resultado.total}
                                </Badge>
                            </Col>
                        </Row>
                    </div>

                    <div className="responsive-table" style={{ minHeight: 400 }}>
                        <Table hover size="sm">
                            <thead style={{ zIndex: 49 }}>
                                <tr>
                                    <th>#</th>
                                    <th>Nível</th>
                                    <th>Timestamp</th>
                                    <th>Método</th>
                                    <th>Path</th>
                                    <th>Status</th>
                                    <th>Duração</th>
                                    <th>E-mail</th>
                                    <th>Empresa</th>
                                    <th>IP</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && resultado.data.length === 0 ? (
                                    <tr>
                                        <td colSpan={11} className="text-center py-4">
                                            <Spinner animation="border" size="sm" /> Carregando...
                                        </td>
                                    </tr>
                                ) : resultado.data.length === 0 ? (
                                    <tr>
                                        <td colSpan={11} className="text-center py-4">
                                            Nenhum registro encontrado para os filtros selecionados.
                                        </td>
                                    </tr>
                                ) : (
                                    resultado.data.map((log, idx) => (
                                        <tr key={idx}>
                                            <td>{((paginaNormalizada - 1) * ITENS_POR_PAGINA) + idx + 1}</td>
                                            <td>
                                                <Badge bg={levelVariant(log.level)}>
                                                    {log.level}
                                                </Badge>
                                            </td>
                                            <td style={{ whiteSpace: "nowrap" }}>{log.timestamp}</td>
                                            <td>
                                                <Badge bg="dark">{log.requisicao?.method}</Badge>
                                            </td>
                                            <td style={{ maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {log.requisicao?.path}
                                            </td>
                                            <td>{log.resposta?.statusCode}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{log.resposta?.duration}</td>
                                            <td style={{ maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {log.usuario?.email}
                                            </td>
                                            <td>{log.companyId}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{log.requisicao?.ip}</td>
                                            <td>
                                                <i
                                                    className="bi bi-eye"
                                                    style={{ cursor: "pointer", fontSize: "1rem" }}
                                                    title="Ver detalhes"
                                                    onClick={() => setDetalhes(log)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex flex-wrap justify-content-between align-items-center px-2 pt-2 pb-1">
                        <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                            Exibindo {inicioFaixa} a {fimFaixa} de {totalRegistros} registros
                        </div>
                        <Pagination className="mb-0" size="sm">
                            <Pagination.First
                                onClick={() => setPaginaAtual(1)}
                                disabled={loading || paginaNormalizada === 1}
                            />
                            <Pagination.Prev
                                onClick={() => setPaginaAtual((p) => Math.max(1, p - 1))}
                                disabled={loading || paginaNormalizada === 1}
                            />
                            {paginasVisiveis.map((p) => (
                                <Pagination.Item
                                    key={p}
                                    active={p === paginaNormalizada}
                                    onClick={() => setPaginaAtual(p)}
                                    disabled={loading}
                                >
                                    {p}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next
                                onClick={() => setPaginaAtual((p) => Math.min(totalPaginas, p + 1))}
                                disabled={loading || paginaNormalizada === totalPaginas}
                            />
                            <Pagination.Last
                                onClick={() => setPaginaAtual(totalPaginas)}
                                disabled={loading || paginaNormalizada === totalPaginas}
                            />
                        </Pagination>
                    </div>
                </div>
            </Card>

            {detalhes && (
                <ModalDetalhesLog
                    log={detalhes}
                    onClose={() => setDetalhes(null)}
                />
            )}

            {error.show && <ModalErrorPretty setShow={setError} {...error} />}
        </Fragment>
    )
}

const methodBadgeColor = (method) => {
    const m = (method || "").toUpperCase()
    if (m === "GET") return "#2962ff"
    if (m === "POST") return "#28a745"
    if (m === "DELETE") return "#dc3545"
    if (m === "PUT" || m === "PATCH") return "#ffc107"
    return "#6c757d"
}

const statusBadgeColor = (code) => {
    if (!code) return "#6c757d"
    if (code < 300) return "#28a745"
    if (code < 400) return "#17a2b8"
    if (code < 500) return "#ffc107"
    return "#dc3545"
}

const ROW_STYLE = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "10px 0",
    borderBottom: "1px solid #f0f0f0",
    gap: 8,
}

const LABEL_STYLE = {
    color: "#888",
    fontSize: "0.85rem",
    minWidth: 110,
    flexShrink: 0,
}

const VALUE_STYLE = {
    fontSize: "0.9rem",
    fontWeight: 500,
    textAlign: "right",
    wordBreak: "break-word",
    flex: 1,
}

function LogRow({ label, children }) {
    return (
        <div style={ROW_STYLE}>
            <span style={LABEL_STYLE}>{label}</span>
            <span style={VALUE_STYLE}>{children}</span>
        </div>
    )
}

function ColapsavelDados({ icone, titulo, dados }) {
    const [aberto, setAberto] = useState(false)
    const entradas = dados ? Object.entries(dados) : []
    if (!entradas.length) return null
    return (
        <div
            style={{
                border: "1px solid #ebebee",
                borderRadius: 8,
                marginBottom: 8,
                overflow: "hidden",
            }}
        >
            <div
                onClick={() => setAberto((v) => !v)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "11px 14px",
                    background: "#f8f9fa",
                    cursor: "pointer",
                    userSelect: "none",
                }}
            >
                <span style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "0.9rem", fontWeight: 500 }}>
                    <i className={`bi ${icone}`} style={{ color: "#555" }}></i>
                    {titulo} <Badge bg="secondary" style={{ fontSize: "0.7rem" }}>{entradas.length}</Badge>
                </span>
                <i className={`bi bi-chevron-${aberto ? "up" : "down"}`} style={{ color: "#888" }}></i>
            </div>
            <Collapse in={aberto}>
                <div style={{ padding: "8px 14px 4px" }}>
                    {entradas.map(([k, v]) => (
                        <div
                            key={k}
                            style={{
                                border: "1px solid #ebebee",
                                borderRadius: 6,
                                padding: "7px 10px",
                                marginBottom: 6,
                                fontSize: "0.82rem",
                                wordBreak: "break-all",
                            }}
                        >
                            <span style={{ fontWeight: 600 }}>{k}:</span>{" "}
                            {typeof v === "object" ? JSON.stringify(v) : String(v)}
                        </div>
                    ))}
                </div>
            </Collapse>
        </div>
    )
}

function ModalDetalhesLog({ log, onClose }) {
    const method = log.requisicao?.method || ""
    const statusCode = log.resposta?.statusCode
    const path = log.requisicao?.path || ""

    return (
        <Modal show onHide={onClose} size="md" scrollable>
            <Modal.Header closeButton style={{ borderBottom: "1px solid #ebebee", paddingBottom: 12 }}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 12, width: "100%" }}>
                    <Badge
                        style={{
                            background: methodBadgeColor(method),
                            fontSize: "0.8rem",
                            padding: "5px 10px",
                            borderRadius: 6,
                            flexShrink: 0,
                            marginTop: 2,
                        }}
                    >
                        {method}
                    </Badge>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                            <span
                                style={{
                                    fontWeight: 600,
                                    fontSize: "0.88rem",
                                    wordBreak: "break-all",
                                    flex: 1,
                                }}
                            >
                                {path}
                            </span>
                            <Badge
                                style={{
                                    background: statusBadgeColor(statusCode),
                                    fontSize: "0.78rem",
                                    padding: "4px 8px",
                                    borderRadius: 6,
                                    flexShrink: 0,
                                }}
                            >
                                {statusCode}
                            </Badge>
                        </div>
                        <div style={{ fontSize: "0.78rem", color: "#888", marginTop: 2 }}>
                            {log.timestamp}
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body style={{ padding: "0 20px" }}>
                <LogRow label="Data/Hora">{log.timestamp}</LogRow>
                <LogRow label="Método">{method}</LogRow>
                <LogRow label="Endpoint">
                    <span style={{ wordBreak: "break-all" }}>{path}</span>
                </LogRow>
                <LogRow label="URL Completa">
                    <span style={{ wordBreak: "break-all" }}>{log.requisicao?.url}</span>
                </LogRow>
                <LogRow label="Status">
                    {statusCode} {log.resposta?.statusMessage}
                </LogRow>
                <LogRow label="Duração">{log.resposta?.duration}</LogRow>
                <LogRow label="Usuário">{log.usuario?.nome || `#${log.userId}`}</LogRow>
                <LogRow label="E-mail">{log.usuario?.email}</LogRow>
                <LogRow label="Empresa ID">{log.companyId}</LogRow>
                <LogRow label="IP">{log.requisicao?.ip}</LogRow>

                {log.resposta?.errorMessage && (
                    <LogRow label="Mensagem">
                        <span style={{ color: "#dc3545" }}>{log.resposta.errorMessage}</span>
                    </LogRow>
                )}

                {/* SEÇÕES COLAPSÁVEIS */}
                <div style={{ marginTop: 12, marginBottom: 8 }}>
                    <ColapsavelDados
                        icone="bi-sliders"
                        titulo="Parâmetros"
                        dados={log.dados?.params}
                    />
                    <ColapsavelDados
                        icone="bi-sliders"
                        titulo="Query"
                        dados={log.dados?.query}
                    />
                    <ColapsavelDados
                        icone="bi-braces"
                        titulo="Body"
                        dados={log.dados?.body}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer style={{ padding: "12px 20px", borderTop: "1px solid #ebebee" }}>
                <Button
                    variant="dark"
                    onClick={onClose}
                    style={{ width: "100%", borderRadius: 8, padding: "10px 0", fontSize: "0.95rem" }}
                >
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
